import { lazy } from 'react';
import { Route } from 'react-router-dom';
import NotFound from '../../pages/OtherPage/NotFound';

const EventsShell = lazy(() => import('../../pages/Events/EventsShell'));
const EventsReconciliation = lazy(
  () => import('../../pages/Events/EventsReconciliation'),
);
const EventsInquiries = lazy(
  () => import('../../pages/Events/EventsInquiries'),
);
const EventsPipeline = lazy(() => import('../../pages/Events/EventsPipeline'));
const EventsBooking = lazy(() => import('../../pages/Events/EventsBooking'));
const EventsApprovals = lazy(
  () => import('../../pages/Events/EventsApprovals'),
);
const EventsSettings = lazy(() => import('../../pages/Events/EventsSettings'));

/** Child routes rendered through EventsLayout's <Outlet />. */
export function eventsChildRoutes() {
  return (
    <>
      <Route index element={<EventsShell />} />
      <Route path="inquiries" element={<EventsInquiries />} />
      <Route path="inquiries/:leadId" element={<EventsInquiries />} />
      <Route path="pipeline" element={<EventsPipeline />} />
      <Route path="bookings/:bookingId" element={<EventsBooking />} />
      <Route path="approvals" element={<EventsApprovals />} />
      <Route path="settings" element={<EventsSettings />} />
      <Route path="settings/:tab" element={<EventsSettings />} />
      <Route path="reconciliation" element={<EventsReconciliation />} />
      <Route path="*" element={<NotFound />} />
    </>
  );
}
